export default __webpack_public_path__ + "static/media/default-thumbnail.fd33ab69.png";